import script from "./CommandInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CommandInput.vue?vue&type=script&setup=true&lang=js"

import "./CommandInput.vue?vue&type=style&index=0&id=3389287c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3389287c"]])

export default __exports__